import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import styles from './RatingsAttribute.module.less'
import ReviewIcon from 'Assets/icons/review.svg'
import { UpdatableReactElement } from 'shared/utils/react.utils'

export const RatingsAttribute = (props: { element: UpdatableReactElement }) => {
    return (
        <div className={styles['rate-responses-container']} data-testid="rate-responses-container">
            <PanelHeader title={'Rate the Responses'} actionButtons={[]} logo={ReviewIcon} />
            {props.element.element}
        </div>
    )
}
